
import React from 'react';
import { cn } from '@/lib/utils';
import { BotStatus, BotType, ColorScheme, ExchangePlatform } from '@/types/trader';
import { CardHeader } from './bot-card/CardHeader';
import { BotInfo } from './bot-card/BotInfo';
import { CardActions } from './bot-card/CardActions';
import { colorSchemeStyles, defaultCardStyles } from '@/components/premium-bots/utils/styles';

interface BotCardProps {
  id: string;
  name: string;
  type: BotType;
  status: BotStatus;
  description: string;
  connectedAccounts: number;
  className?: string;
  colorScheme?: ColorScheme;
  exchange: ExchangePlatform[]; // Array of exchanges
  onViewDetails: (id: string) => void;
  onToggleStatus: (id: string, currentStatus: BotStatus) => void;
  onDelete: (id: string) => void;
}

export const BotCard = ({
  id,
  name,
  type,
  status,
  description,
  connectedAccounts,
  className,
  colorScheme,
  exchange,
  onViewDetails,
  onToggleStatus,
  onDelete
}: BotCardProps) => {
  // Determine which style to use
  const cardStyle = colorScheme ? colorSchemeStyles[colorScheme] : defaultCardStyles[type];

  return (
    <div className={cn(
      'rounded-lg p-5 card-shine transition-all duration-300 hover:translate-y-[-2px]',
      cardStyle,
      className
    )}>
      <CardHeader
        name={name}
        status={status}
        type={type}
        colorScheme={colorScheme}
      />
      
      <BotInfo
        description={description}
        connectedAccounts={connectedAccounts}
        exchanges={exchange}
      />
      
      <CardActions
        id={id}
        status={status}
        onViewDetails={onViewDetails}
        onToggleStatus={onToggleStatus}
        onDelete={onDelete}
      />
    </div>
  );
};
